import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/layout/chat_dark.svg'
import _imports_1 from '@/assets/img/forum/topic.svg'
import _imports_2 from '@/assets/img/management/add.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3e8d705c")

_pushScopeId("data-v-3e8d705c")
const _hoisted_1 = { class: "hasAdminButtonsFooter" }
const _hoisted_2 = { class: "fs_18 greyBlue d-block fw_700" }
const _hoisted_3 = { class: "fs_13 greyBlue d-block ln_12 mt-2" }
const _hoisted_4 = { class: "footerInformationContainer" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "fs_13 greyBlue ms-1" }
const _hoisted_8 = {
  key: 1,
  class: "fs_9 greyBlue"
}
const _hoisted_9 = { class: "adminButtonContainer" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.topics.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_ancoranientealmomento",
          text: "Ancora niente al momento",
          class: "fs_14 greyBlue d-block ln_12 mt-5 text-center"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topics, (topic, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "topicContainer mb-3",
        key: index,
        onClick: ($event: any) => (_ctx.showPosts(topic))
      }, [
        _createVNode("span", _hoisted_2, "#" + _toDisplayString(topic.tag.tag), 1),
        _createVNode("span", _hoisted_3, _toDisplayString(topic.tag.description), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("span", _hoisted_7, "Post (" + _toDisplayString(topic.postsCount) + ")", 1)
          ]),
          (topic.postsCount == 0)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "app_ancoranientealmomento",
                text: "Ancora niente al momento",
                class: "fs_9 greyBlue"
              }))
            : (_openBlock(), _createBlock("span", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_ultimo",
                  text: "Ultimo:",
                  class: "me-1"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(topic.lastPublishedPostDate)), 1)
              ]))
        ])
      ], 8, ["onClick"]))
    }), 128)),
    _createVNode("div", _hoisted_9, [
      (_ctx.$store.state.community.canSettings)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "managementButton",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editTags()))
          }, [
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.$store.state.community.canContent || _ctx.$store.state.community.isLiked)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: "managementButton",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPost()))
          }, [
            _hoisted_11
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})